import { createAPI } from "../apisServer";

import BaseUrl from "../baseUrls";

const banco = BaseUrl.dataBase;
const apiServer = createAPI("multiTenant");

const reqEmpresaBanner = {
	listPaginate: async function (param, paramValue, active, page) {
		return apiServer
			.get("portal/v1/empresa-banner", {
				params: {
					param,
					paramValue,
					active,
					page,
					perpage: 15,
				},
				headers: {
					banco: banco,
					page,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
	listId: async function (id) {
		return apiServer
			.get(`portal/v1/empresa-banner/${id}`, {
				headers: {
					banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
	insert: async function (data) {
		return apiServer
			.post("portal/v1/empresa-banner", data, {
				headers: {
					banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
};

export default reqEmpresaBanner;
